import { render, staticRenderFns } from "./SendEmailDetail.vue?vue&type=template&id=b67f1390&scoped=true&"
import script from "./SendEmailDetail.vue?vue&type=script&lang=js&"
export * from "./SendEmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailDetail.vue?vue&type=style&index=0&id=b67f1390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67f1390",
  null
  
)

export default component.exports